// Must match the server's reserved runtime map range. These maps are private,
// ephemeral and available only through an admitted connection's file transfer.
export function isPrivateMapId(id:number):boolean {
  return Number.isInteger(id) && id>=60000 && id<=63999;
}
